import { _Flicking } from './flicking'

// Flicking登録
if (!window?.Flicking) window.Flicking = _Flicking;

jQuery(() => {
    // 里親募集一覧ページの「保護場所」チェックボックスのチェック状態をURLに反映する
    if (document.getElementById('js-protection-shelter-checkboxes') === null) return;

    const $jsProtectionShelterCheckboxes = jQuery('#js-protection-shelter-checkboxes input[name="protection_shelter"]');

    $jsProtectionShelterCheckboxes.on('change', (event) => {

        const url = new URL(window.location.href);
        url.searchParams.delete('protection_shelter');
        url.searchParams.delete('protection_shelter[]');
        url.searchParams.delete('protection_shelter[0]');
        url.searchParams.delete('protection_shelter[1]');
        url.searchParams.delete('protection_shelter[2]');
        url.searchParams.delete('protection_shelter[3]');
        url.searchParams.delete('protection_shelter[4]');

        $jsProtectionShelterCheckboxes.each((i, v) => {
            const $v = jQuery(v);
            const vValue = $v.val();
            if ($v.is(':checked')) url.searchParams.append('protection_shelter[]', vValue);
        });

        window.location.replace(url)
    });
});